// mediaBrowserSelect.js — ISP-9999 (C5.6): pure selection logic extracted from
// MediaBrowser's `handleSave`, so the Browse-tab select branches can be unit
// asserted without mounting the component / its redux + mutation deps.
//
// Behaviour-preserving: these are the exact decisions `handleSave` made inline.
//   - image/images  → persist via saveExternalImage, use the returned S3 url.
//   - everything else (video/document/audio) → use the RAW selected url as-is
//     (NO saveExternalImage round-trip).
//   - saveRecentMedia metadata.type is "youtube" ONLY for video, "" otherwise.

// Does this media type get persisted through save-external-image before use?
// Only true images do; a selected video (youtube) keeps its raw URL. (C5.6)
export function isExternalImageType(mediaType) {
  return mediaType === "image" || mediaType === "images";
}

// The `type` code sent to saveRecentMedia. Mirrors the original switch exactly:
// no default case → returns undefined for an unknown type.
export function getRecentMediaFileType(mediaType) {
  switch (mediaType) {
    case "images":
      return "0";
    case "image":
      return "0";
    case "video":
      return "1";
    case "documents":
      return "2";
    case "audio":
      return "3";
    default:
      return undefined;
  }
}

// saveRecentMedia metadata.type: a selected Browse video is a youtube embed;
// all other types carry an empty metadata type. (C5.6)
export function getRecentMediaMetadataType(mediaType) {
  return mediaType === "video" ? "youtube" : "";
}
